export const TEXTBOX = 'TEXTBOX';
export const CHECKBOX = 'CHECKBOX';
export const DROPDOWN = 'DROPDOWN';
export const RADIOS = 'RADIOS';
export const MULTISELECT = 'MULTISELECT';
